import * as dd from 'dingtalk-jsapi'

/**
 * 参数转成对象
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
    decodeURIComponent(search)
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"')
    .replace(/\+/g, ' ') +
    '"}'
  )
}


/**
 * 判断是否是微信浏览器
 * @returns {boolean}
 */
export const isWeiXin = () => {
  let check = navigator.userAgent.toLowerCase().indexOf('micromessenger');
  return (check !== -1) ? true : false;
}

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = url => {
  let paramObj = {}
  if (url.indexOf("?") != -1) {
    const keyValueArr = url.split('?')[1].split('&');
    keyValueArr.forEach(item => {
      const keyValue = item.split('=')
      paramObj[keyValue[0]] = keyValue[1]
    })
  }
  return paramObj
}


/**
 * 深拷贝
 * @param source
 * @returns {[]|{}}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 * 国际时间转年月日时分秒
 * @param source
 * @returns String
 */
export function getymd(date) {
  var date = new Date(date)
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var day = date.getDate();
  var hour = date.getHours();
  var minute = date.getMinutes();
  var second = date.getSeconds();
  return year + '-' + formatTen(month) + '-' + formatTen(day) + " " + formatTen(hour) + ':' + formatTen(minute) + ':' + formatTen(second);
}

export function dateFormat(longTypeDate, fmt) {
  var date = longTypeDate instanceof Date ? longTypeDate : new Date(longTypeDate)
  var o = {   
    "M+" : date.getMonth()+1,                 //月份   
    "d+" : date.getDate(),                    //日   
    "h+" : date.getHours(),                   //小时   
    "m+" : date.getMinutes(),                 //分   
    "s+" : date.getSeconds(),                 //秒   
    "q+" : Math.floor((date.getMonth()+3)/3), //季度
    "S"  : date.getMilliseconds()             //毫秒   
  }  
  if(/(y+)/.test(fmt)){
    fmt=fmt.replace(RegExp.$1, (date.getFullYear()+"").substr(4 - RegExp.$1.length))
  } 
  for(var k in o){
    if(new RegExp("("+ k +")").test(fmt)){
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length==1) ? (o[k]) : (("00"+ o[k]).substr((""+ o[k]).length)))
    } 
  }   
  return fmt
}

/** 
 * 获取当前年月日时分秒
 */
export function formatDate() { 
  let time = new Date() 
    // 获取年
   let year = time.getFullYear() 
    // 获取月
    let month = time.getMonth()+1
      month = month < 10 ? '0' + month : month
    // 获取日
    let date = time.getDate() 
      date = date < 10 ? '0' + date : date
    // 获取时
    let hours = time.getHours()
      hours = hours < 10 ? '0' + hours : hours
    // 获取分
    let minutes = time.getMinutes()
      minutes = minutes < 10 ? '0' + minutes : minutes
    // 获取秒
    let second = time.getSeconds()
      second = second < 10 ? '0' + second : second
  return year + "/" + month + "/" + date + " " + hours + ":" + minutes + ":" + second
}

/**
 * 加法
 */
export const addSub = (arg1, arg2) => { 
  arg1 = arg1.toString(), arg2 = arg2.toString(); // 将传入的数据转化为字符串
  var arg1Arr = arg1.split("."), // 将小数的数据从小数点的位置拆开
  arg2Arr = arg2.split("."),
  d1 = arg1Arr.length == 2 ? arg1Arr[1] : "", // 获取第一个数的小数点的长度
  d2 = arg2Arr.length == 2 ? arg2Arr[1] : ""; // 获取第二个数的小数点的长度
  var maxLen = Math.max(d1.length, d2.length); // 获取小数点长度较大的值
  var m = Math.pow(10, maxLen); // 这里表示10的小数点长度次方 也就是说如果小数点长度为2 m的值就是100 如果小数点长度是3 m的值就是1000如果不懂请自行查找api
  var result = Number(((arg1 * m + arg2 * m) / m).toFixed(maxLen)); // 将小数转化为整数后相加在除掉两个数乘过的倍数然后去小数点较长的长度的小数位数
  return typeof d === "number" ? Number(result) : result;
} 

/**
 * 时间不满十进0
 * @param source
 * @returns String
 */
function formatTen(num) {
  return num > 9 ? (num + '') : ('0' + num);
}

/**
 * 计算两个时间之间的时间差 （分）
 * time1: 开始时间
 * time2：结束时间
 */
 export function TimeDifference(time1,time2) { 
  if (time1 > time2) { 
    return '';
  }
  //截取字符串，得到日期部分"2009-12-02",用split把字符串分隔成数组
  var begin1 = time1.substr(0, 10).split("-");
  var end1 = time2.substr(0, 10).split("-");
  //将拆分的数组重新组合，并实例成化新的日期对象
  var date1 = new Date(begin1[1] + - +begin1[2] + - +begin1[0]);
  var date2 = new Date(end1[1] + - +end1[2] + - +end1[0]);
  //得到两个日期之间的差值m，以分钟为单位
  //Math.abs(date2-date1)计算出以毫秒为单位的差值
  //Math.abs(date2-date1)/1000得到以秒为单位的差值
  //Math.abs(date2-date1)/1000/60得到以分钟为单位的差值
  var m = parseInt(Math.abs(date2 - date1) / 1000 / 60);
  //小时数和分钟数相加得到总的分钟数
  //time1.substr(11,2)截取字符串得到时间的小时数
  //parseInt(time1.substr(11,2))*60把小时数转化成为分钟
  var min1 = parseInt(time1.substr(11, 2)) * 60 + parseInt(time1.substr(14, 2));
  var min2 = parseInt(time2.substr(11, 2)) * 60 + parseInt(time2.substr(14, 2));
  //两个分钟数相减得到时间部分的差值，以分钟为单位
  var n = min2 - min1;
  //将日期和时间两个部分计算出来的差值相加，即得到两个时间相减后的分钟数
  var minutes = m + n;
  return minutes;
}

/**
 * 获取url上的参数
 * @param {string} url
 * @returns {Object}
 */
 export function getQueryObject(url) {
  url = url == null ? window.location.href : url
  const search = url.substring(url.lastIndexOf('?') + 1)
  const obj = {}
  const reg = /([^?&=]+)=([^?&=]*)/g
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1)
    let val = decodeURIComponent($2)
    val = String(val)
    obj[name] = val
    return rs
  })
  return obj
}

export function titleConfig(title) {
  if (dd.env.platform === 'notInDingTalk') {
    document.title = title
  } else {
    // 设置钉钉导航栏标题 start
    dd.biz.navigation.setTitle({
      title: title, // 控制标题文本，空字符串表示显示默认文本
      onSuccess: result => {},
      onFail: err => console.error('设置导航栏标题错误', err)
    })
  }  
}

/** 
 * @param tree 扁平化 数据
 * @param type 前后数据 "front"/"back"
 */
 export const treeFlat = (tree, type) => {
  let newArr = []
  if(tree.length) {
    tree.forEach(item => {
      let newObj = {}  
      // 前端权限路由
      if(type === 'front') {
        newObj = deepClone(item)
        delete newObj.children
        newArr.push(newObj)  
        //判断是否有子元素
        if(item.children){ 
          newArr = newArr.concat(treeFlat(item.children,'front'))  
        }  
      }

      // 后端权限路由 如果不是接口类型就push 
      if(type === 'back' && item.type !== 3) {  
        newObj = deepClone(item) 
        delete newObj.childList
        newArr.push(newObj) 
        //判断是否有子元素
        if(item.childList.length){ 
          newArr = newArr.concat(treeFlat(item.childList,'back'))
        }   
      } 
    })
  }
  return newArr
}

/**
 * 根据后端返回的权限标记映射权限
 *  @param frontRouter 前端扁平化路由
 *  @param endRouter 返回数组权限标记(树形结构)
 */
export const filterRouterFun = (frontRouter, endRouter) => {
  // 如果没有前端路由或者没有后端路由权限，则返回空数组
  if(!frontRouter.length || !endRouter.length) {
    return []
  }
  const routeTree = []
    frontRouter.forEach(frt => {
    // 查询当前路由是否有响应的后端权限
    const isAuthFrontRouter = endRouter.find(ert => ert.menuCode === frt.name)
    if (isAuthFrontRouter) {
      routeTree.push(frt)
    }
  })  
  
  return routeTree;
}

export const str2obj = (str) => {
  let obj
  try {
    obj = JSON.parse(str)
  } catch (error) {
    return obj
  }
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const element = obj[key]
      if(typeof element == 'string' && /^\{.*\}$|^\[.*\]$/.test(element)) {
        obj[key] = str2obj(`${element}`)
      }
    }
  }
  return obj
}

/**
 * @param {Object} json
 * @returns {Array}
 */
 export function param(json) {
  if (!json) return ''
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return ''
      return encodeURIComponent(key) + '=' + encodeURIComponent(json[key])
    })
  ).join('&')
}

/**
 * 获取当前年月日时分秒
 * */
export const getAllCurrentTime = () => { 
  var newDate = new Date(); //获取今天日期
  let newYear = newDate.getFullYear(),
      newMonth = newDate.getMonth() + 1,
      newDay = newDate.getDate(),
      newHouse = newDate.getHours(),
      newMin = newDate.getMinutes(),
      newSeco = newDate.getSeconds()
      newMonth = newMonth >= 10 ? newMonth : '0' + newMonth,
      newDay = newDay >= 10 ? newDay : '0' + newDay
  let newTime = newYear + '-' + newMonth + '-' + newDay + ' ' + newHouse + ':' + newMin + ':' + newSeco;
  return newTime;
}

export const base64ToBlobUrl = (base64Data) => { 
   // 提取 MIME 类型和 Base64 编码部分
   const parts = base64Data.split(';base64,');
   const mimeType = parts[0].split(':')[1];
   let base64 = parts[1];

   if (!base64) {
       console.error('Invalid Base64 data');
       return null;
   }

   // 过滤非法字符
   base64 = base64.replace(/[^A-Za-z0-9+/=]/g, '');

   // 填充 Base64 字符串
   while (base64.length % 4) {
       base64 += '=';
   }

   // 将 Base64 数据转换为二进制数据
   const binary = atob(base64);
   const array = [];
   for (let i = 0; i < binary.length; i++) {
       array.push(binary.charCodeAt(i));
   }

   // 创建 Blob 对象
   const blob = new Blob([new Uint8Array(array)], { type: mimeType });

   // 创建对象 URL
   const blobUrl = URL.createObjectURL(blob);
   return blobUrl;
}
 
/**
 * 判断是否是移动端
 * @returns {boolean}
 */
export const detectDeviceType = () => { 
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // 检测移动设备
  if (/windows phone/i.test(userAgent)) {
      return "Mobile";
  }
  if (/android/i.test(userAgent)) {
      return "Mobile";
  }
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "Mobile";
  }

  // 检测iPad
  var isiPad = (/iPad/i.test(userAgent) && !window.MSStream);
  if (isiPad) {
      return "Tablet";
  }

  // 检测电脑端（非移动设备且非iPad）
  if (!isiPad && !(/android/i.test(userAgent)) && !(/windows phone/i.test(userAgent)) && !(/iPad|iPhone|iPod/.test(userAgent))) {
      return "Desktop";
  }
} 